@if ($job(); as job) {
    <ng-template #icon>
        @if ($isJobPending()(job) && (job.progress ?? 0) > 0) {
            <mat-progress-spinner [mode]="'determinate'" [diameter]="16" [value]="job.progress"></mat-progress-spinner>
        } @else {
            <i [class]="$iconClass()" [class.cm-job-icon-complete]="isJobComplete(job)" [class.cm-job-icon-error]="$isJobError()(job)"> </i>
        }
    </ng-template>
    <!-- While pending or failed, staff can click the status icon to jump straight to the job. -->
    @if (($isJobPending()(job) || $isJobError()(job)) && $can().read.menu("jobs")) {
        <a class="cm-job-link" [routerLink]="['/jobs', job.id]" [matTooltip]="$tooltip() + ' · open job'">
            <ng-container [ngTemplateOutlet]="icon"></ng-container>
        </a>
    } @else {
        <div [matTooltip]="$tooltip()">
            <ng-container [ngTemplateOutlet]="icon"></ng-container>
        </div>
    }
}
